import $i18n from 'panda-i18n';
import React, { useCallback } from 'react';
import { setLocale, getLocale, defaultLang } from '@/locales/locale';
import styles from './index.module.scss';
import { Icon, MenuButton } from '@fpxfd/next';
import { vToLabel } from '@/utils';

const { Item } = MenuButton;

const menu = [
  {
    name: '中文',
    code: 'zh-CN',
  },

  {
    name: 'English',
    code: 'en-US',
  },

  {
    name: 'Español',
    code: 'es-ES',
  },

  {
    name: 'Italiano',
    code: 'it-IT',
  },

  {
    name: 'русский язык',
    code: 'ru-RU',
  },

  {
    name: '日本語',
    code: 'ja-JP',
  },
  {
    name: 'عرب .',
    code: 'ar-SA',
  },
  {
    name: 'Français',
    code: 'fr-FR',
  },
  {
    name: '한국',
    code: 'ko_KR',
  },
];

interface MenuItem {
  code: string;
  name: string;
}

export default () => {
  const lang = getLocale();
  const sysLang = menu.find((e) => e.code.includes(lang.split(/-|_/)[1]));
  // const langName = sysLang ? sysLang.name : $i18n.get({ id: 'Chinese.four_px', dm: '中文' });
  const langName = sysLang ? sysLang.name : vToLabel(menu, defaultLang(window.location.host));
  const selectLang = useCallback((val: string) => {
    setLocale(val);
    window.localStorage.removeItem('wareMenu');
    window.localStorage.removeItem('wareMenuList');
    window.sessionStorage.clear();
  }, []);

  return (
    <div data-i18n-ignore-content>
      <MenuButton
        label={langName}
        text
        popupTriggerType="click"
        popupClassName={styles.langPop}
        onItemClick={(value) => selectLang(value)}
        className={styles.Lang}
        autoWidth={false}
      >
        {menu &&
          menu.map((item: MenuItem) => (
            <Item data-i18n-ignore-content key={item.code}>
              {item.name}
            </Item>
          ))}
      </MenuButton>
    </div>
  );
};
